export class Subcategoria {

    public id:number;
    public nombre:string;
    public descipcion:string;
    public codigoCategoria:string;
    public codigoSubCategoria:string;
    public codigoConsorcio:string;

}



// WEBPACK FOOTER //
// D:/TPL ILG/3PL_ILG/src/app/model/subcategoria.ts